import Handsontable from 'handsontable';
import { getAllCellsBetween } from '../tableCellSelectionUtils';

export const getHotTableCellBackgroundColor = (
    hotInstance: Handsontable,
    cellSelections = hotInstance.getSelected(),
): string | null | undefined => {
    if (!cellSelections) return null;

    const colors = new Set<string>();
    getAllCellsBetween(cellSelections).forEach((cell): void => {
        const { row, col } = cell;
        colors.add(hotInstance?.getCellMeta(row, col)?.cellData?.background || null);
    });

    const values = Array.from(colors);

    // We need to return something other than null if multiple cells are selected
    if (values.length > 1) return undefined;

    // If only one cell is selected, return the color
    // otherwise return null - this is considered the first color in the color picker which
    // is the element background color
    return values.length === 1 ? values[0] : null;
};
